import {useSelector, useDispatch} from 'react-redux';
import { setActiveConversation, createNewConversation, setSelectedPortfolio } from '../../../store/slices/gpt.slice';
import { v4 as uuidv4 } from 'uuid';


const useChatbox = () => {
    const dispatch = useDispatch();

    const selectedPortfolioId = useSelector((state) =>
        state.gptApi.selectedPortfolioId);
    const portfolioDocument = useSelector((state) =>
        state.portfolios.items?.find((p) => p.id === selectedPortfolioId));


    const handleSelectPortfolio = (portfolio, allConversations) => {
      // Set selected portfolio in Redux
      dispatch(setSelectedPortfolio(portfolio.id));

      // Check for existing portfolio conversation
      const existingConversation = allConversations.find(
        (conv) => conv.groupId === portfolio.id  // Compare groupId instead of id
      );

      if (existingConversation) {
        // Switch to existing conversation
        dispatch(setActiveConversation(existingConversation.id));
      } else {
        // Create new conversation with portfolio.id as groupId
        const newConversationId = uuidv4(); // Generate unique conversation ID
        dispatch(
          createNewConversation({
            id: newConversationId,
            isPortfolio: true,
            portfolioId: portfolio.id  // This will be used as groupId
          })
        );
      }
    };

    return {
        selectedPortfolioId,
        portfolioDocument,
        handleSelectPortfolio
    }

}


export default useChatbox;